<template>
  <div class="login"
       v-loading.fullscreen.lock="loading"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="login-container">
      <img style="width:350px;height:100px" src="../../assets/images/logo-hh.jpg" />
    </div>
    <el-main class="form-container">
      <div class="login-form">
        <el-form class="el-form"
                 ref="loginForm"
                 :model="loginForm"
                 :rules="rules">
          <div class="login-title">
            <h3>报告平台登录</h3>
          </div>
          <el-form-item prop="EmpCode">
            <!--<label class="account-num">账号 Account</label>-->
            <i class="iconfont icon-font-name name"></i>
            <span class="login-tip" v-show="empName">{{ empName }}</span>
            <el-input ref="empcode"
                      name="EmpCode"
                      type="text"
                      tabindex="1"
                      v-model="loginForm.EmpCode"
                      placeholder="请输入账号"
                      v-on:keydown.enter.native="enterEmpCode"
                      class="emp-input" />
          </el-form-item>
          <el-form-item class="pwd-con" prop="Password">
            <i class="iconfont icon-font-pwd pwd"></i>
            <el-input ref="password"
                      name="Password"
                      type="password"
                      tabindex="2"
                      autocomplete="on"
                      placeholder="请输入密码"
                      class="password-input"
                      v-model="loginForm.Password"
                      v-on:keydown.enter.native="enterPassword">
            </el-input>
          </el-form-item>
          <el-form-item prop="VerifyCode" style="margin-top: 2.5rem;width:290px;margin-bottom: 0.5rem;">
            <el-input ref="verifyCode"
                      class="verify_css"
                      placeholder="请输入4位验证码"
                      v-model="loginForm.VerifyCode"
                      v-on:keydown.enter.native="login"></el-input>
            <div id="v_container"></div>
          </el-form-item>
          <el-form-item class="login-tip-con" style="margin-bottom:0.5rem">
            <el-checkbox v-model="loginForm.rememberPwd">记住密码</el-checkbox>
            <span class="print-info" v-on:click="printControl">打印控件</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="login-button" v-on:click="login">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-main>
    <el-footer class="footer-con">
      <p>2020©杭州莱域科技有限公司提供技术支持 | 本系统建议使用<span class="browser-info">谷歌浏览器</span>打开</p>
    </el-footer>

    <el-dialog width="500px"
               :visible.sync="dlgMessageVerifyVisiable"
               :close-on-click-modal="false">
      <span slot="title" class="dialog-title"> 短信认证 </span>
      <div>
        <el-form @submit.native.prevent
                 size="medium"
                 label-width="90px"
                 style="width: 450px"
                 :inline="true"
                 class="form-input">
          <el-row>
            <el-form-item label="短信验证码" class="">
              <el-input v-model="messageVerifyCode"
                        placeholder="请输入短信验证码"
                        v-on:keydown.enter.native="CheckMessageVerifyCode"
                        style="width: 200px"></el-input>
            </el-form-item>
            <el-button size="mini"
                       type="primary"
                       :disabled="regetButtonDisable"
                       class="regetButton"
                       v-on:click="regetMessageVerifyCode">{{ regetButtonText + (regetTime > 0 ? ('(' + regetTime + ')') : '') }}</el-button>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium"
                   type="primary"
                   v-on:click="CheckMessageVerifyCode">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import request from '@/utils/request'
  import { getLodop } from '@/utils/lodopFuncs'
  import { downloadLodop } from '@/utils/lodopFuncs'
  import { GVerify } from '@/utils/verifyCode';
export default {
  data() {
    const validateEmpCode = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      empName: "",
      empRole: "",
      loginForm: {
        EmpCode: "",
        Password: "",
        rememberPwd: false,
        VerifyCode: ''
      },
      messageVerifyCode: '',
      dlgMessageVerifyVisiable: false,
      regetTime: 0,
      regetButtonDisable: false,
      regetButtonText: '重新获取',

      rules: {
        EmpCode: [
          { required: true, trigger: "blur", validator: validateEmpCode },
        ],
        Password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
      },
      redirect: undefined,
      otherQuery: {},
      //验证码
      verifyCode: null,
    };
  },
  computed: {},
  async mounted() {
    if (this.$refs)
      this.$refs.empcode.focus();
    let empInfo = this.common.getCookie("empInfo")||'';
    if (empInfo.rememberPwd==true) {
      this.loginForm.EmpCode = empInfo.EmpCode||'';
      this.loginForm.Password = empInfo.Password||'';
      this.loginForm.rememberPwd = true;
    }
    this.verifyCode = new GVerify('v_container');
  },
  methods: {
    enterPassword() {
      this.$refs.verifyCode.focus();
    },
    enterEmpCode() {
      this.$refs.password.focus();
    },
    //打印控件
    printControl() {
      var LODOP = downloadLodop();
      if (LODOP.errorHtml) {
        this.$alert(('<div style="line-height:24px">' + LODOP.errorHtml + '</div>'), {
          confirmButtonText: '确定',
          showClose: false,
          dangerouslyUseHTMLString: true,
          confirmButtonClass: 'iconfont icon-font-success',
          iconClass: 'iconfont icon-font-error',
          customClass: 'custom-message-box-1'
        });
        return;
      }
      //else {
      //  this.$message({
      //    message: '打印控件已安装',
      //    type: "success",
      //  });
      //}
    },
    //登录
    login() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          let thi = this;
          this.loading = true;
          this.verifyCode.validateServer(this.loginForm.EmpCode, this.loginForm.VerifyCode, function (r) {
            thi.loading = false;
            if (r.Flag == 1) {
              if (r.NeedMsgCertify) {
                thi.showMessageVerifyCode();
              }
              else {
                thi.doLogin();
              }
            }
            else {
              thi.$message({
                message: "验证码错误",
                type: "error",
              });
              thi.refreshVerifyCode();
              thi.$refs.verifyCode.focus();
            }
          });
        } else {
          return false;
        }
      });
    },

    showMessageVerifyCode() {
      this.loading = true;
      request.post("/api/Biz/SendMessageVerifyCode", {
        EmpCode: this.loginForm.EmpCode
      }).then((r) => {
        this.loading = false;
        if (r.Flag == 1) {
          this.messageVerifyCode = '';
          this.dlgMessageVerifyVisiable = true;
        }
        else {
          this.$message({
            message: r.ErrorMsg,
            type: "error",
          });
        }
      });
    },

    refreshVerifyCode() {
      this.verifyCode.refresh();
      this.loginForm.VerifyCode = "";
    },

    refreshButtonState() {
      this.regetTime = this.regetTime - 1;
      if (this.regetTime <= 0) {
        this.regetButtonDisable = false;
      }
      else {
        setTimeout(this.refreshButtonState, 1000);
      }
    },

    regetMessageVerifyCode() {
      request.post("/api/Biz/SendMessageVerifyCode", {
        EmpCode: this.loginForm.EmpCode
      }).then((r) => {
        if (r.Flag == 1) {
          this.$message({
            message: '短信已发送',
            type: "success",
          });
          this.regetButtonDisable = true;
          this.regetTime = 60;
          setTimeout(this.refreshButtonState, 1000);
        }
        else {
          this.$message({
            message: r.ErrorMsg,
            type: "error",
          });
        }
      });
    },

    CheckMessageVerifyCode() {
      if (this.messageVerifyCode == '') {
        this.$message({
          message: '请输入验证码',
          type: "error",
        });
        return;
      }
      this.loading = true;
      request.post("/api/Biz/CheckMessageVerifyCode", {
        EmpCode: this.loginForm.EmpCode,
        VerifyCode: this.messageVerifyCode
      }).then((r) => {
        this.loading = false;
        if (r.Flag == 1) {
          this.messageVerifyCode = '';
          this.dlgMessageVerifyVisiable = false;
          this.doLogin();
        }
        else {
          this.$message({
            message: r.ErrorMsg,
            type: "error",
          });
        }
      });
    },

    doLogin() {
      this.loading = true;
      this.loginForm.Password = this.common.Md5Encrypt(this.loginForm.Password);
      request.post('/api/Login/Login', this.loginForm).then((r) => {
        this.loading = false;
        if (r.Success == true) {
          let empInfo = {
            EmpCode: this.loginForm.EmpCode,
            Password: this.loginForm.Password,
            rememberPwd: this.loginForm.rememberPwd,
            Name: this.empName,
          }

          this.common.setCookie("empInfo", empInfo);
          this.common.setCookie("userInfo", r.UserInfo);
          this.common.setCookie("token", r.Token);
          this.$store.commit('initNewState');
          if (r.UserInfo.UserLevelId != 1)
            this.$store.commit('openMsgWindow');
          else
            this.$store.commit('closeMsgWindow');
          this.$router.push({ path: "/biz/FrmReport", query: {} });
        } else {
          this.$message({
            message: r.Message,
            type: "error",
          });
          this.refreshVerifyCode();
        }
      }).catch((r) => {
        this.loading = false;
      })
    }
  },
};
</script>

<style lang="scss" scoped="">
    .login {
      background: url('~@/assets/images/bg.png') no-repeat center center;
      background-size:100% 100%;
      width:100%;
      height:100%;
      overflow:hidden;
    }
  .login .login-container {
    text-align: center;
    margin-top: 40px;
    width: 500px;
    position: absolute;
    left: 50%;
    top: 0;
    margin-left: -250px;
  }
      .login .form-container {
        width: 470px;
        height: 480px;
        position: absolute;
        top: 140px;
        left: 50%;
        margin-left: -235px;
        z-index: 9;
      }
    .login .form-container .login-form {
      width: 394px;
      height: 100%;
      margin: 0 auto;
      background-color: rgba(255,255,255,1);
      box-shadow: 0 0 13px 6px rgba(60,129,236,0.3);
      border-radius: 8px;
    }
    .login .login-form .el-form {
      height: 100%;
      width: 100%;
    }
    .login .login-title {
      margin-bottom: 36px;
      margin-top: 36px;
    }
    .login .login-title h3{
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      color: rgba(51,51,51,1);
    }
    .login .login-form .el-form-item {
      width: 310px;
      margin: 0 auto;
      margin-bottom:22px;
    }
    .login .login-form .pwd-con {
      margin-bottom: 10px;
    }
    .login .login-form .el-form-item .el-input {
      width: 270px;
      height: 48px;
      line-height: 48px;
      padding-left: 14px;
    }
    .login .login-form .el-form-item > > > .el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      position: absolute;
      top: 100%;
      left: 30px;
    }
    .login .login-form .el-form-item > > > .el-input__inner {
      width: 270px;
      height: 48px;
      border-top: none;
      border-left: none;
      border-right: none;
      border-radius: 0;
      border-bottom-color: #e0e0e0;
      font-size: 14px;
    }
    .login .login-form .el-form-item .pwd-con {
      margin-top: 22px;
    }
    .password-input{
    }
    .login .login-button {
      width: 310px;
      background-color: rgba(27,154,238,1)!important;
      border-color: rgba(27,154,238,1)!important;
      height: 48px;
      color: #fff;
      font-size: 16px;
      letter-spacing: 4px;
    }
  .login .el-button.el-button--primary, body .el-button.el-button--primary:focus {
    color: #fff;
    font-size: 16px;
    letter-spacing: 4px;
  }
  .login .login-button:hover {
    background-color: rgba(27,154,238,1);
    border-color: rgba(27,154,238,1)
  }
    .login .login-tip-con .el-checkbox >>> .el-checkbox__input{
      width:18px;
      height:18px;
    }
    .login .login-tip-con .el-checkbox > > > .el-checkbox__inner {
      width: 18px;
      height: 18px;
      border: 1px solid #666666;
    }
    .login .login-tip-con .el-checkbox > > > .el-checkbox__inner::after {
      height: 10px;
      left: 4px;
      position: absolute;
      top: 0px;
      width: 7px;
    }
    .login .login-tip-con .el-checkbox > > > .el-checkbox__label {
      font-size: 14px;
      color: rgba(51,51,51,1);
    }
    .login .login-tip-con .print-info {
      display: inline-block;
      float: right;
      font-size: 14px;
      color: rgba(27,154,238,1);
      cursor:pointer;
    }
  .footer-con {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 60px;
    text-align: center;
    width: 100%;
    line-height: 60px;
  }
    .footer-con p{
      text-align:center;
      font-size:12px;
      color:rgba(51,51,51,1);
    }
    .footer-con .browser-info{
      font-size:12px;
      color:#1b9aee;
      cursor:pointer;
    }
    .name{
      font-size:14px;
      font-weight:bold;
    }
    .pwd {
      font-size: 14px;
      font-weight: bold;
    }
    .el-input >>> input::-webkit-input-placeholder{
      padding-left:24px;
    }

  #v_container {
    width: auto;
    height: auto;
    display: inline-flex;
    position: relative;
    margin-top: -2.5rem;
    float: right;
  }

  .verify_css {
    float: left;
    margin-top: -2rem;
    width: 100px;
  }

  .regetButton {
    margin-top: 2px;
    width: 125px;
    height: 33px;
  }

    .regetButton > > > span {
      line-height: 18px;
      letter-spacing:0px;
    }
</style>



// WEBPACK FOOTER //
// src/views/system/login.vue